import React, { CSSProperties, FC } from 'react'

/** Outlined circle-i information icon for AI feature panels. */
const AIInfoIcon: FC<{ className?: string; style?: CSSProperties }> = ({ className = '', style }) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 13 13"
        fill="none"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        data-testid="ai-info-icon"
    >
        <path
            d="M5.91029 5.91017L5.93209 5.89927C6.23318 5.74873 6.57219 6.02067 6.49054 6.34725L6.11807 7.83716C6.03642 8.16373 6.37543 8.43568 6.67652 8.28514L6.69832 8.27424M11.0324 6.30418C11.0324 8.91546 8.91558 11.0323 6.3043 11.0323C3.69303 11.0323 1.57617 8.91546 1.57617 6.30418C1.57617 3.69291 3.69303 1.57605 6.3043 1.57605C8.91558 1.57605 11.0324 3.69291 11.0324 6.30418ZM6.3043 4.33413H6.30824V4.33807H6.3043V4.33413Z"
            stroke="currentColor"
            strokeWidth="0.788022"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AIInfoIcon
